import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Filters from './Filters/';
import AdvertsList from './AdvertsList';
import Map from './Map/';

import { setDesktopDevice } from '../reducers/viewportSlice';
import { setDisplay as setMapDisplay } from '../reducers/mapSettingsSlice';

export const ListingAds = () => {
  const { requestPropertiesState } = useSelector((state) => state.properties);
  const { selectedTab } = useSelector((state) => state.filters);
  const { desktopDevice } = useSelector((state) => state.viewportSlice);
  const { display: showMap } = useSelector((state) => state.mapSettings);
  const dispatch = useDispatch();

  useEffect(() => {
    // Set desktopDevice on initial load
    dispatch(setDesktopDevice(window.innerWidth));

    const handleResize = () => {
      const width = window.innerWidth;
      dispatch(setDesktopDevice(width));
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div id='listing-properties'>
      {requestPropertiesState === 'pending' && selectedTab !== 'mobileFilters' && (
        <div className='loading-layer-sized no-background vesta-loading-overlay'>
          <div className='spinner-loader-centered spinner-loader-big'></div>
        </div>
      )}

      <div className={desktopDevice ? 'vesta-desktop' : 'vesta-mobile'}>
        <Filters />

        <div className={showMap && desktopDevice ? 'vesta-grid' : ''}>
          <AdvertsList />

          {showMap && <Map />}
        </div>

        <div style={{ position: 'fixed', bottom: '20px', right: '0px', zIndex: 1000 }} className='vesta-display-desktop'>
          <div onClick={() => dispatch(setMapDisplay(!showMap))} className='vesta-button--primary vesta-button--icon-left'>
            <i className='fa fa-map vesta-button--icon-left'></i>
            <span className='typo-h4'>{showMap ? 'Masquer la carte' : 'Voir la carte'}</span>
          </div>
        </div>
      </div>
    </div>
  )
};

export default ListingAds;
